import { render, staticRenderFns } from "./RequestDocuments.vue?vue&type=template&id=04eb03b7&scoped=true"
import script from "./RequestDocuments.vue?vue&type=script&lang=js"
export * from "./RequestDocuments.vue?vue&type=script&lang=js"
import style0 from "./RequestDocuments.vue?vue&type=style&index=0&id=04eb03b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb03b7",
  null
  
)

export default component.exports